import { getStroke } from 'perfect-freehand';
import type { Point } from '@blackboard/shared';

export interface FreehandOpts {
  size: number;
  thinning?: number;
  smoothing?: number;
  streamline?: number;
  simulatePressure?: boolean;
}

export function strokePath(points: Point[], opts: FreehandOpts): number[][] {
  if (points.length === 0) return [];
  const raw = points.map((p) => [p.x, p.y, p.pressure] as [number, number, number]);
  return getStroke(raw, {
    size: opts.size,
    thinning: opts.thinning ?? 0.6,
    smoothing: opts.smoothing ?? 0.5,
    streamline: opts.streamline ?? 0.5,
    simulatePressure: opts.simulatePressure ?? false,
    last: true,
  });
}

export function pathToPath2D(outline: number[][]): Path2D {
  const p = new Path2D();
  if (outline.length === 0) return p;
  const [x0, y0] = outline[0]!;
  p.moveTo(x0!, y0!);
  for (let i = 1; i < outline.length; i++) {
    const [x, y] = outline[i]!;
    p.lineTo(x!, y!);
  }
  p.closePath();
  return p;
}
